/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeEvent, memo } from "react";
import { Control, useController } from "react-hook-form";
import { Input } from "tvs-unified-lib";

export interface InputFieldProps {
  label?: string;
  name: string;
  control: Control<any>;
  isRequired?: boolean;
  placeholder?: string;
  icon?: React.ReactNode;
  type?: string;
  disabled?: boolean;
  onChange?: (e: ChangeEvent) => void;
  numberOnly?: boolean;
}

export const InputField = memo(
  ({
    label,
    name,
    control,
    isRequired = false,
    placeholder,
    icon,
    type,
    disabled = false,
    onChange,
    numberOnly = false,
  }: InputFieldProps) => {
    const {
      field: { onChange: onChangeController, value },
      fieldState: { error },
    } = useController({ name, control });

    return (
      <Input
        name={name}
        placeholder={placeholder}
        value={value ?? ""}
        type={type}
        formLabel={label}
        isRequired={isRequired}
        onInputChange={(e: any) => {
          if (numberOnly) {
            e.target.value = e.target.value.replace(/[^0-9]/g, "");
          }
          onChangeController(e);
          onChange?.(e);
        }}
        hasError={!!error}
        errorMessage={error?.message}
        icon={icon}
        disabled={disabled}
      />
    );
  }
);

export default InputField;
